import { LogOut } from "lucide-react";
import { useState } from "react";

import { useAuth } from "@/auth/AuthProvider";
import { Button, Dialog, IconButton } from "@/ui";

/**
 * The shell's "Sign out": asks first, as the apps and the agents do, so a stray click on the corner of the sidebar
 * (or the phone's menu) does not end the session. Signing out of the console does not check anybody out.
 */
export function SignOutButton() {
  const { signOut } = useAuth();
  const [asking, setAsking] = useState(false);
  const close = () => setAsking(false);

  return (
    <>
      <IconButton size="small" tooltip="left" onClick={() => setAsking(true)} label="Sign out">
        <LogOut aria-hidden />
      </IconButton>
      <Dialog
        open={asking}
        size="small"
        title="Sign out?"
        onClose={close}
        onSubmit={() => {
          close();
          void signOut();
        }}
        footer={
          <>
            <Button onClick={close}>Stay signed in</Button>
            <Button type="submit" variant="primary">Sign out</Button>
          </>
        }
      >
        <p>You'll sign in again with your email and password to use Zotula in this browser. Signing out doesn't check you out.</p>
      </Dialog>
    </>
  );
}
